import request from './request';

export default {
    get_geo_data: function (params = {}) {
        return request('/geo', params, 'get')
            .then(({data}) => data)
    },
}
